import React, { useEffect, useState } from "react";
import { Pagination } from "react-bootstrap";
import { getWalletTransactions } from "../../../../api/walletTransaction";

const WithdrawTable = () => {
  const rowsPerPage = 10;
  const [activePage, setActivePage] = useState(1);
  const [withdrawData, setWithdrawData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchWithdrawTransactions = async () => {
      setLoading(true);
      try {
        const response = await getWalletTransactions({
          page: activePage,
          limit: rowsPerPage,
          type: "sell",
        });

        setWithdrawData(response.data.data || []);
        setTotalCount(response.data.total || 0);
        setError(null);
      } catch (err) {
        setError("Failed to fetch withdraw transactions");
      } finally {
        setLoading(false);
      }
    };

    fetchWithdrawTransactions();
  }, [activePage]);

  const formatStatus = (status) => {
    if (status === "pending") return "Pending Approval";
    if (status === "confirm") return "Approved";
    if (status === "cancel") return "Rejected";
    return status || "N/A";
  };

  const totalPages = Math.ceil(totalCount / rowsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setActivePage(page);
    }
  };

  const renderPagination = () => {
    if (totalPages <= 1) return null;

    const items = [];
    const visiblePages = 5;

    let startPage = Math.max(1, activePage - Math.floor(visiblePages / 2));
    let endPage = startPage + visiblePages - 1;

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - visiblePages + 1);
    }

    for (let number = startPage; number <= endPage; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === activePage}
          onClick={() => handlePageChange(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    return (
      <Pagination className="mt-4 pagination-gutter pagination-primary no-bg">
        {items}
      </Pagination>
    );
  };

  if (loading) return <p>Loading withdraw transactions...</p>;
  if (error) return <p className="text-danger">{error}</p>;

  return (
    <div className="table-responsive dataTablehistory">
      <div id="withdrawdata_wrapper" className="dataTables_wrapper no-footer">
        <table
          className="table dataTable shadow-hover display"
          style={{ minWidth: "845px" }}
        >
          <thead>
            <tr>
              <th>Date</th>
              <th>Amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {withdrawData.length > 0 ? (
              withdrawData.map((item, index) => {
                const date = item.createdAt
                  ? new Date(item.createdAt).toLocaleString()
                  : "N/A";

                const amount = Number(item.amount || item.quantity || 0).toFixed(
                  2
                );
                const status = item.status || "N/A";

                return (
                  <tr key={item.id || index}>
                    <td>{date}</td>
                    <td>{amount}</td>
                    <td>{formatStatus(status)}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={3} className="text-center">
                  No withdrawal records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="d-flex justify-content-center w-100 mt-3 mb-3">
          {renderPagination()}
        </div>
      </div>
    </div>
  );
};

export default WithdrawTable;
